module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/file-settings/file-settings.component.css
// module id = ./src/app/modules/file-settings/file-settings.component.css
// module chunks = main